import React from 'react';
function CaloriesTable({ caloriesBurned, bmr, maintain, mildLoss, lose, extremeLoss, mildGain, gain, extremeGain }) {
    return (
        <table >
            <thead>
                <tr>
                    <th >Weight Management Status</th>
                    <th >Calories (Daily)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Maintain Weight</td>
                    <td>{maintain}</td>
                </tr>
                <tr>
                    <td>Mild Weight Loss (0.25 kg/week)</td>
                    <td>{mildLoss}</td>
                </tr>
                <tr>
                    <td>Weight Loss (0.5 kg/week)</td>
                    <td>{lose}</td>
                </tr>
                <tr>
                    <td>Extreme Weight Loss (1 kg/week)</td>
                    <td>{extremeLoss}</td>
                </tr>
                <tr>
                    <td>Mild Weight Gain (0.25 kg/week)</td>
                    <td>{mildGain}</td>
                </tr>
                <tr>
                    <td>Weight Gain (0.5 kg/week)</td>
                    <td>{gain}</td>
                </tr>
                <tr>
                    <td>Extreme Weight Gain (1 kg/week)</td>
                    <td>{extremeGain}</td>
                </tr>
                <tr>
                    <td colSpan="2">Total Consumed/Burned Calories: {caloriesBurned} (Daily)</td>
                </tr>
                <tr>
                    <td colSpan="2">Basal Metabolic Rate (BMR): {bmr}</td>
                </tr>
            </tbody>
        </table>
    );
}
export default CaloriesTable;
